<template>
  <v-container class="container">
    <div class="div">
      <h1 class="primary--text mb-6 mainHeading">Personvernerklæring</h1>

      <p>Sist endret: 04.10.2019</p>

      <p>Denne siden informerer om hvordan og hvorfor vi samler inn, bruker og sikrer personlig informasjon når du bruker Dine Oppskrifter.</p>

      <p>
        Vi bruker din data for å operere og forbedre Dine Oppskrifter. Ved å bruke Dine Oppskrifter, aksepterer du at vi samler inn og bruker informasjon som samsvarer med denne personverkerklæringen. Dersom ikke annet er skrevet, så har uttrykkene brukt i denne personvernerklæringen samme betydning som i
        <router-link to="/vilkaar-for-bruk">vilkår for bruk</router-link>.
      </p>

      <h2 class="secondary--text headline mb-4 mt-8">Innsamling og bruk av informasjon</h2>
      <p>Vi samler inn flere typer informasjon av flere grunner for å gi deg den beste opplevelsen og forbedre oss.</p>

      <h3 class="accent--text title mb-2 mt-4">Data vi samler inn</h3>
      <h4 class="info--text subtitle-2 mb-2 mt-4">Personlig informasjon</h4>
      <p>Ved bruk av Dine Oppskrifter vil vi kunne spør deg om å gi oss indentifiserbar informasjon som kan bli brukt til å kontakte eller identifisere deg (Personlig informasjon). Identifiserbar informasjon inkluderer følgende:</p>
      <ul class="mb-4">
        <li>Epostaddresse</li>
        <li>Fornavn og etternavn</li>
        <li>Informasjonskapsler og bruksdata</li>
      </ul>

      <h4 class="info--text subtitle-2 mb-2 mt-4">Bruksdata</h4>
      <p>Vi kan også samle inn informasjon om hvordan Dine Oppskrifter blir nådd og brukt (bruksdata). Bruksdata kan inkludere informasjon som din enhets "Internett protokoll addresse" (for eksempel IP adresse), hvilken nettleser du bruker, hvike sider på Dine Oppskrifter du besøker, tid og dato du besøker de sidene, hvor lang tid du bruker på de sidene og andre diagnostikk-data</p>
      <p>
        <strong>NB!</strong> Vi samler
        <strong>ikke</strong> inn hvordan du bruker andre nettsteder, kun hva du foretar deg inne på våre sider (dine-oppskrifter.no).
      </p>

      <h4 class="info--text subtitle-2 mb-2 mt-4">Sporing- og informasjonskapseldata</h4>

      <p>Vi bruker Informasjonskapsler og lignende sporingsteknologier for å følge med på hvordan du bruker Dine Oppskrifter og til å holde på noe informasjon.</p>

      <p>Informasjonskapsler er filer med små mengder data som kan inkludere en anonym unik identitet. Informasjonskapsler blir sendt til din nettleser fra en nettside og lagret på din enhet. Sporingsteknologier som også er brukt er "beacons", "tags" og "scripts" for å samle og spore informasjon, og forbedre og analysere Dine Oppskrifter.</p>

      <p>Det er mulig å gjøre slik at nettleseren din nekter å lagre Informasjonskapsler eller vise når en kapsel blir sendt.</p>
      <p>
        <strong>NB!</strong> Dersom du ikke aksepterer Informasjonskapsler, vil du ikke kunne bruke alle funksjonene til Dine Oppskrifter. Du kan lære mer om Informasjonskapsler i
        <router-link
          to="https://privacypolicies.com/blog/how-to-delete-cookies/"
          target="_blank"
        >Browser Cookies Guide</router-link>.
      </p>Eksempler på Informasjonskapsler vi bruker:
      <ul>
        <li>
          <strong>Session-kapsler.</strong> Vi bruker "Session-kapsler" for å holde deg innlogget.
        </li>
        <li>
          <strong>Preferansekapsler.</strong> Vi bruker Preferansekapsler for å huske dine preferanser på nettsiden og diverse innstillinger.
        </li>
        <li>
          <strong>Sikkerhetskapsler.</strong> Vi bruker Sikkerhetskapsler for sikkerhetsformål.
        </li>
      </ul>

      <h2 class="secondary--text headline mb-4 mt-8">Bruk av data</h2>

      <p>Dine Oppskrifter bruker innsamlet data til flere formål:</p>
      <ul>
        <li>For å operere og vedlikeholde Dine Oppskrifter.</li>
        <li>For å informere deg om endringer på Dine Oppskrifter.</li>
        <li>For å tillate deg å bruke interaktive funksjoner på nettsidene våre når du ønsker.</li>
        <li>For å tilby brukerstøtte.</li>
        <li>For å tilby analyser eller verdifull informasjon slik at vi kan forbedre Dine Oppskrifter.</li>
        <li>For å følge med på bruken av Dine Oppskrifter.</li>
        <li>For å oppdage, forhindre og fikse tekniske problemer.</li>
      </ul>

      <h2 class="secondary--text headline mb-4 mt-8">Overførsel av data</h2>
      <p>Din informasjon, inkludert din personlige informasjon, kan bli overført til, og vedlikeholdt på, datamaskiner utenfor ditt land eller annen myndighetens jurisdiksjon hvor databeskyttelseslover kan være forskjellig.</p>
      <p>Dersom du befinner deg utenfor Norge og velger å gi oss informasjon, vær oppmersom på at vi kan overføre din data (inkludert personlig informasjon) til Norge og behandle det der.</p>
      <p>Ved å akseptere denne personverkerklæringen etterfulgt av å logge inn og gi oss din informasjon, representerer det din godkjennelse for denne overføringen</p>
      <p>Dine Oppskrifter vil ta alle nødvendige steg for å sikre at din informasjon blir behandlet og lagret sikkert og i henhold til denne personvernerklæringen, og ingen overføring av din personlige informasjon vil forekomme til andre organisasjoner eller myndigheter.</p>

      <h2 class="secondary--text headline mb-4 mt-8">Utlevering av data</h2>
      <p>
        Dine Oppskrifter vil
        <strong>ikke</strong> utlevere personlig informasjon til noen andre enn det som er beskrevet i denne personvernerklæringen.
      </p>

      <h2 class="secondary--text headline mb-4 mt-8">Sikring av data</h2>
      <p>Sikkerhet av dine data er veldig viktig for oss, men husk at det ikke finnes overføring over internett eller elektronisk lagring som er 100% sikker. Vi vil gjøre vårt ytterste for at din personlige informasjon er så sikker som mulig, men vi kan ikke garantere absolutt sikkerhet.</p>

      <h2 class="secondary--text headline mb-4 mt-8">Tjenestetilbydere</h2>
      <p>Vi bruker tjenester fra tredjeparts selskaper for å ta hånd om enkelte funksjoner på Dine Oppskrifter.</p>
      <p>Disse tredjepart tjenestene blir brukt:</p>
      <ul>
        <li>
          <strong>Firebase.</strong> Blir brukt til å ta hånd om nettsiden, lagring av all informasjon, og innlogging av brukere ved hjelp av Facebook, nevnt under.
        </li>
        <li>
          <strong>Facebook.</strong> Blir brukt for å gi deg en rask og enkel måte å logge inn på våre nettsider.
        </li>
      </ul>
      <h2 class="secondary--text headline mb-4 mt-8">Lenker til andre nettsteder</h2>
      <p>Våre nettsider kan inneholde lenker til andre nettsteder som ikke tilhører oss. Dersom du trykker på en lenke som går til et tredjepart nettsted, vil du bli dirigert til det nettstedet. Vi anbefaler å lese gjennom Personvernerklæringen til alle nettsteder du besøker.</p>
      <p>Vi har ingen kontroll over og tar ingen ansvar for innholdet, personvernerklæringen eller praktiseringen av noen andre nettsteder eller tjenester</p>

      <h2 class="secondary--text headline mb-4 mt-8">Endringer av denne personvernerklæringen</h2>
      <p>Vi vil kunne endre denne personverkerklæringen av og til. Den nye vil komme på denne siden, og ved oppdatering av personverkerklæringen vil det komme frem et varsel på forsiden neste gang du besøker den.</p>
      <p>Vi anbefaler at du sjekker personverkerklæringen av og til for endringer. Endringene trer i kraft når de legges ut på denne siden.</p>

      <h2 class="secondary--text headline mb-4 mt-8">Kontakt oss</h2>
      <p>
        Dersom du har spørsmål om denne personverkerklæringen eller noe annet tilknyttet Dine Oppskrifter, kan du sende en e-post til
        <a
          href="mailto:brukerstotte@dine-oppskrifter.no"
        >brukerstotte@dine-oppskrifter.no</a> eller besøke
        <router-link class="mr-1" to="/kontakt-oss">kontakt oss siden</router-link>for flere måter å kontakte oss.
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "privacyPolicy",
  metaInfo() {
    return {
      title: "Personvernerklæring - Dine Oppskrifter"
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
  display: flex;
  justify-content: center;
}

.div {
  max-width: 1200px;
}

.mainHeading {
  font-size: 1.9rem;
  font-weight: 400;
}

@media only screen and (min-width: 800px) {
  .div {
    margin: 30px;
  }
}
</style>